module.exports = __webpack_public_path__ + "img/sales-i-logo.a142b2a7.svg";